"use client";

import { useEffect } from "react";

/**
 * Al abrir la home con `/#seccion` (p. ej. desde otra página), hace scroll a la ancla.
 */
export function LandingHashScroll() {
  useEffect(() => {
    const raw = window.location.hash.replace(/^#/, "");
    if (!raw) return;
    const el = document.getElementById(raw);
    if (!el) return;
    const id = window.setTimeout(() => {
      const smooth = !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      el.scrollIntoView({ behavior: smooth ? "smooth" : "auto", block: "start" });
    }, 100);
    return () => clearTimeout(id);
  }, []);
  return null;
}
